import UrlsService from '../../../../common/router/services/urlsService.mdl';
import NavLinkGroup from '../../../app/components/main-menu/components/nav-link-group/NavLinkGroup';

export default function ReportingLinks(): React.JSX.Element {

    return (
        <NavLinkGroup to={UrlsService.reporting()} label="Reporting" iconName="icon-reporting"/>
    );
}
